export const environment = {
    production: false,
    apiBaseUrl: 'https://api2.test.flysas.com/',
    translationFileBaseUrl: '../../translations/sasui-onboard/onboard_',
    paxPageSuffix: '/classic/#/onboard',
    apiTimeout: 60000
};
